export default __webpack_public_path__ + "static/media/apply_new.61c5004c.png";